import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../utils/types";
import { getStatisticsOverall } from "../../../redux/educator/actions";
import {
  selectStatisticsOverall,
  selectStatisticsOverallLoaded,
} from "../../../redux/educator/selector";
import { getLessonDemand } from "../../../redux/learner/actions";
import {
  selectLessonDemands,
  selectLessonDemandsLoaded,
} from "../../../redux/learner/selector/lessonDemand";

const mapStateToProps = (state: StateType) => ({
  statistics: selectStatisticsOverall(state),
  loaded: selectStatisticsOverallLoaded(state),
  lessonDemands: selectLessonDemands(state),
  lessonDemandsLoaded: selectLessonDemandsLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getStatisticsOverall,
      getLessonDemand,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
